<template>
  <div class="providers-search" style="width: 100%">
    <b-input-group >
      <template #append>
        <b-button v-if="addAllowed" @click="$refs.providerModal.show()">+</b-button>
      </template>
      <v-select class="form-control" v-bind:multiple="multiple"
                :loading="loading" :options="items" v-model="selected"
                label="name" @search="searchProviders" @input="onProviderSelected"
      >
      </v-select>
    </b-input-group>
    <provider-modal ref="providerModal" @updated="updateSelectedProvider"/>
  </div>
</template>


<script>
import ProviderModal from "@/components/modals/providers/ProviderModal.vue";
import {mapActions} from "vuex";

export default {
  name: "providersSearch",
  components: {ProviderModal},
  props:{
    addAllowed:{type: Boolean, default: false},
    multiple: {type: Boolean, default: false},
  },
  data: () => ({
    loading: false,
    items: [],
    selected: {},
  }),
  created() {
    this.searchProviders("", () => {});
    if(this.multiple) {
      this.selected = [];
    } else {
      this.selected = null;
    }
  },
  methods:{
    ...mapActions("providers", ["fetchAllProviders"]),
    searchProviders(text, loading) {
      let $this = this;
      let filter = {name: text};
      this.loading = true;
      loading(true);
      this.fetchAllProviders({page:1, amount:25, filter, sortcolumn:"name", sortby: "ASC"}).then(data => {
        $this.items = data.Providers;
      }).finally(() => {
        $this.loading = false;
        loading(false);
      })
    },
    onProviderSelected(input) {
      console.log("onProviderSelected", {input, selected: this.selected});
      if(this.multiple) {
        if(this.selected != null && this.selected.length > 0) {
          this.$emit("selected", this.selected.map(item => item.id));
          this.$emit("input", this.selected.map(item => item.id));
        } else {
          this.$emit("selected", []);
          this.$emit("input", []);
        }
      }else {
        if(this.selected == null || this.selected.id == null){
          this.$emit("selected", null);
          this.$emit("input", null);
          return;
        }
        this.$emit("selected", this.selected.id);
        this.$emit("input", this.selected.id);
      }

    },
    updateSelectedProvider(provider) {
      console.log("updateSelectedProvider", {providers: this.providers, provider});
      this.items.push(provider);
      if(this.multiple) {
        if(this.selected == null || this.selected.length === 0) {
          this.selected = [];
        }
        this.selected = this.selected.push(provider);
      } else {
        this.selected = provider;
      }
    },
  }
}
</script>

<style scoped>

</style>